import { render, staticRenderFns } from "./m-divider.vue?vue&type=template&id=87bf7476&scoped=true&"
import script from "./m-divider.vue?vue&type=script&lang=js&"
export * from "./m-divider.vue?vue&type=script&lang=js&"
import style0 from "./m-divider.vue?vue&type=style&index=0&id=87bf7476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bf7476",
  null
  
)

export default component.exports